<template>
  <div class="middle cadfm-flexitem-stretched">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button  @click="back" icon="back" bold :text="lang.button_Back"
            :title="lang.button_Back" :disabled="backButtonStatus"/>
          


        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold :text="lang.button_Left"
            :title="lang.button_Left" :disabled="toggleButtonStatus"/>
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold :text="lang.button_Right"
            :title="lang.button_Right" :disabled="toggleButtonStatus"/>

        </b-navbar-nav>
      </action-bar>
      <action-content>
        <Content   :lang="lang.Content"></Content>
      </action-content>
    </action-panel>
  </div>
</template>

<script>
  import ActionBar from '@/components/shared/ActionBar'
  import ActionButton from '@/components/shared/ActionButton'
  import ActionContent from '@/components/shared/ActionContent'
  import ActionPanel from '@/components/shared/ActionPanel'


  import Content from "@/components/ProjectManager/Views/ProjectImportIPC/Middle/Content/Content"

//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'Middle',
  components:{
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    Content

  },
  props:{
    lang: Object
  },

  data () {
    return {
      toggleButtonStatus: false,
      importButtonStatus: true,
      backButtonStatus: false,
      imported: false,

    }
  },
  computed:{
    

  },
  created() {

    
  },
  watch: {
    

  },
  methods: {
    
    back(){


      let to = this.$route.query.from;

      

      const query = {
        from: this.$route.path,
        to: to,
        revisionId: this.$route.query.revisionId,
        id: this.$route.query.id
      }

      this.$router.push({ path: to, query: query });
    },
    toggleRightPanel(){
      console.log(this.$parent.isVisibleRight)
      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;
      console.log(this.$parent.isVisibleRight)
    },
    toggleLeftPanel(){
      console.log(this.$parent.isVisibleLeft)
      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;
      console.log(this.$parentisVisibleLeft)
    }
  }
}
</script>


<style scoped>

  .middle{
    border-right: 1px solid #666;
  }

</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectImportIPC/Middle/Middle.vue